module.exports = __webpack_public_path__ + "img/field-level-endzone-gal-6.6c9632fc.jpg";